var rtl_rtlignore_default = {
  "rtl": "Diy8-",
  "ltr": "_2kEHa"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
